// JavaScript Document

jQuery.fn.mailme = function () {
	var at = / at /;
	var dot = / dot /g;
	this.each(function () {
		var addr = jQuery(this).text().replace(at, "@").replace(dot, ".");
		var link = jQuery(this).text().replace(at, "@").replace(dot, ".");
		var title = jQuery(this).attr('title')
		jQuery(this)
			.after('<a href="mailto:' + link + '" title="' + title + '" class="gris">' + addr + '</a>')
			.remove();
	});
};


jQuery(document).ready(function ($) {
	//$('.dropdown-toggle').dropdown();

	$('[data-repeatable]').repeatable();

	$(".btn-display-footer").click(function () {
		$(this).remove();
		$("#footer *").removeClass("hidden-footer");
	})

	$(".onglet dt").click(function () {
		$(".onglet dt, .onglet dd").removeClass("open");

		$(this).addClass("open");
		$(this).next("dd").addClass("open");

	});

	if ($(window).width() > 768) {
		var mdmHeight = $(".mdmHome").height();
		$(".mdmHome .col-sm-3").height(mdmHeight);
	} else {
		$(".mdmHome .col-sm-3").height("auto");
	}

	$(window).resize(function () {
		if ($(window).width() > 768) {
			var mdmHeight = $(".mdmHome").height();
			$(".mdmHome .col-sm-3").height(mdmHeight).css({
				"minHeight": 101
			});
		} else {
			$(".mdmHome .col-sm-3").height("auto");
		}
	});

	if ($("body").hasClass("page-template-page-contact")) {
		if (nomFormation != "") {
			$("#forMessage").text("Bonjour, je désire avoir des information sur le cours " + nomFormation);
		}
	}

	$('span.mailme').mailme();




	$(".testimony-slider ul").bxSlider({
		auto: false,
		slideMargin: 24,
		minSlides: 2,
		controls: true,
		nextSelector: '.testimony-next',
		prevSelector: '.testimony-prev',
		prevText: '<svg width="27" height="19" viewBox="0 0 27 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 1.5L2 9.5L10 17.5" stroke="white" stroke-width="1.5" stroke-linecap="round"/><path d="M2 9.5H25.5" stroke="white" stroke-width="1.5" stroke-linecap="round"/></svg>',
		nextText: '<svg width="27" height="19" viewBox="0 0 27 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 17.5L25 9.5L17 1.5" stroke="white" stroke-width="1.5" stroke-linecap="round"/><path d="M25 9.5H1.5" stroke="white" stroke-width="1.5" stroke-linecap="round"/></svg>',
		minSlides: 1,
		maxSlides: 2,
		slideWidth: 558,
		adaptiveHeight: true,
	});

	$(".article").click(function () {
		var lienArticle = $(this).find("a").attr("href");
		window.location.href = lienArticle;
	});

	$('.related-posts .owl-carousel').owlCarousel({
		items: 2,
		margin: 30
	});

	const activeAnchorElementsOnScroll = function () {
		const windowTop = $(window).scrollTop();

		$('.onglet-formation').each(function (index, elem) {
			const offsetTop = $(elem).offset().top;
			const outerHeight = $(this).outerHeight(true);

			if (windowTop > (offsetTop - 50) && windowTop < (offsetTop + outerHeight)) {
				const anchorId = $(elem).attr('id');
				$(".anchor-link--active").removeClass('anchor-link--active');
				$(".anchor-link[href='#" + anchorId + "']").addClass('anchor-link--active');
			}
		});
	};

	$(window).on('scroll', function () {
		activeAnchorElementsOnScroll();
	});

	const addStickyToAnchorNavMobile = function () {
		if (document.querySelector('.sticky-single-formation-aside')) {
			const stickyAnchorNav = document.querySelector('.sticky-single-formation-aside');

			if ($(window).innerWidth() < 900) {
				stickyAnchorNav.classList.add('sticky-single-formation-aside--mobile');
			} else {
				stickyAnchorNav.classList.remove('sticky-single-formation-aside--mobile');
			}

			$(window).resize(function () {
				if ($(window).innerWidth() < 900) {
					stickyAnchorNav.classList.add('sticky-single-formation-aside--mobile');
				} else {
					stickyAnchorNav.classList.remove('sticky-single-formation-aside--mobile');
				}
			});


			$(window).on('scroll', function () {
				if (document.querySelector('.sticky-single-formation-aside--mobile')) {
					const stickyAnchorNavMobile = $('.sticky-single-formation-aside--mobile');
					const stickyInner = $('.sticky-inner-wrapper')
					const windowTop = $(window).scrollTop();
					const offsetTop = stickyAnchorNavMobile.offset().top;

					if (windowTop > offsetTop) {
						stickyInner.addClass('sticky-mobile');
					} else {
						stickyInner.removeClass('sticky-mobile');
					}
				}
			});
		}
	}

	addStickyToAnchorNavMobile();


	if (document.querySelector('.anchor-links')) {
		const anchorOverfloWGrabbing = function () {
			const anchorNavSlider = document.querySelector('.anchor-links');
			let isDown = false;
			let startX;
			let scrollLeft;

			anchorNavSlider.addEventListener('mousedown', (e) => {
				isDown = true;
				startX = e.pageX - anchorNavSlider.offsetLeft;
				scrollLeft = anchorNavSlider.scrollLeft;
			});
			anchorNavSlider.addEventListener('mouseleave', () => {
				isDown = false;
			});
			anchorNavSlider.addEventListener('mouseup', () => {
				isDown = false;
			});
			anchorNavSlider.addEventListener('mousemove', (e) => {
				if (!isDown) return;
				e.preventDefault();
				const x = e.pageX - anchorNavSlider.offsetLeft;
				const walk = (x - startX) * 3;
				anchorNavSlider.scrollLeft = scrollLeft - walk;
			});
		}
		anchorOverfloWGrabbing()
	}

	// modal form contact

	if (document.querySelector("#single-formation-modal-contact")) {
		const modal = document.querySelector("#single-formation-modal-contact");
		const body = $('body')
		const openModalbuttons = document.querySelectorAll(".js-open-modal");
		const closeModalbuttons = document.querySelectorAll(".js-close-modal");

		for (let openButton of openModalbuttons) {
			openButton.addEventListener("click", () => {
				modal.showModal();
				$(window).scrollTop();
				body.addClass('no-scroll');
			});
		}

		for (let closeButton of closeModalbuttons) {
			closeButton.addEventListener("click", () => {
				modal.close();
				body.removeClass('no-scroll');
			});
		}

		window.onclick = (e) => {
			if (event.target == modal) {
				modal.close();
				body.removeClass('no-scroll');
			}
		}
	}
});